import { AxiosResponse } from "axios"

type ExtendedAxiosError = Error & {
    status: number
    rawError: object | null
}

export default function getResultData<T>(response: AxiosResponse<T>) {
    const { status, data } = response
    if (status >= 200 && status <= 299) { return data }
    const errorData = data as any
    const error = new Error(errorData?.error || "*unknown error*") as ExtendedAxiosError
    error.status = status
    if (errorData?.rawError) { error.rawError = errorData?.rawError }
    throw error
}